import * as fromDatatype from '../datatype-library/index';
import { RuleNodeConditionalFilterInterface } from '../datatype-library/postgresql/json-datatype.model';

export interface JsonDatatypeConditionalFilterInterface extends 
  fromDatatype.HdrDocConditionalFilterInterface, 
  fromDatatype.MultiLineDocFilterInterface,
  fromDatatype.SingleLineDocFilterInterface {}
  
export interface CommissionSchemeCreateMain {
  code: string;
  name: string;
  status: string;
  descr: string;
}

// export class JsonDatatypeConditionalFilterClass implements JsonDatatypeConditionalFilterInterface{
//   hdr_doc_filter: RuleNodeConditionalFilterInterface;
//   multi_line_doc_filter: RuleNodeConditionalFilterInterface;
//   single_line_doc_filter: RuleNodeConditionalFilterInterface;
  
//   constructor(params: JsonDatatypeConditionalFilterInterface){
//     this.hdr_doc_filter = params.hdr_doc_filter; 
//     this.multi_line_doc_filter = params.multi_line_doc_filter; 
//     this.single_line_doc_filter = params.single_line_doc_filter;
//   }
// }

export interface bl_fi_commission_scheme_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  conditional_filter_json: JsonDatatypeConditionalFilterInterface;
  commission_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  usage_json: fromDatatype.JsonDatatypeInterface;
  pricing_bundle_json: fromDatatype.JsonDatatypeInterface;
  payment_logic_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  treatment_json: fromDatatype.TreatmentJsonInterface;
}

export class bl_fi_commission_scheme_hdr_RowClass
  implements bl_fi_commission_scheme_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  conditional_filter_json: JsonDatatypeConditionalFilterInterface;
  commission_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  usage_json: fromDatatype.JsonDatatypeInterface;
  pricing_bundle_json: fromDatatype.JsonDatatypeInterface;
  payment_logic_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  treatment_json: fromDatatype.TreatmentJsonInterface;

  public onCreate(main: CommissionSchemeCreateMain) {
    this.code = main.code;
    this.name = main.name;
    this.status = main.status;
    this.descr = main.descr;
    this.conditional_filter_json = {
      hdr_doc_filter: {
        top_level_logic: "",
        negation_logic: "",
        rules: [],
      },
      multi_line_doc_filter: {
        top_level_logic: "",
        negation_logic: "",
        rules: [],
      },
      single_line_doc_filter: {
        top_level_logic: "",
        negation_logic: "",
        rules: [],
      },
    } as JsonDatatypeConditionalFilterInterface;
    this.treatment_json = {
      treatments: [],
    } as fromDatatype.TreatmentJsonInterface;

    this.treatment_json.treatments.push({
      commission: {
        price_source: "",
        operator: "",
        value: 0,
        point_ccy_guid: "",
        validity_period_days: 0,
      },
      membership_points: {
        price_source: "",
        operator: "",
        value: 0,
        point_ccy_guid: "",
        validity_period_days: 0,
      },
    });
  }
}
